var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "common_contents_wrap", attrs: { id: "profile" } },
      [
        _c("h2", [_vm._v("PROFILE")]),
        _vm._v(" "),
        _c("section", { staticClass: "homepage_profile_wrap" }, [
          _c("table", { staticClass: "profile_table" }, [
            _c("tbody", [
              _c("tr", [
                _c("th", [_vm._v("名前")]),
                _vm._v(" "),
                _c("td", [_vm._v("ＡＲＡＩ")]),
                _vm._v(" "),
                _c("td", [_vm._v("本名です 爆")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Ｈ．Ｎ")]),
                _vm._v(" "),
                _c("td", [_vm._v("蜜柑＾＾")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "ハンゲームも同じ名前でやってます！よかったら友達申請してください♪"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("年齢")]),
                _vm._v(" "),
                _c("td", [_vm._v("２４")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n\t\t\t\t\t\t専門卒業後就職したのでもう社会人4年目になります藁"
                  ),
                  _c("br"),
                  _vm._v("\n\t\t\t\t\t\t早いなあ 藁\t\n\t\t\t\t\t")
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("住み")]),
                _vm._v(" "),
                _c("td", [_vm._v("埼玉県")]),
                _vm._v(" "),
                _c("td", [_vm._v("石川→東京→埼玉")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("資格")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("\n\t\t\t\t\t\t普通自動車免許（第一種）\n\t\t\t\t\t")
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("\n\t\t\t\t\t\tこの前ゴールドになりました！"),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t\tバイクの免許も取りたいなあ〜\n\t\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("趣味")]),
                _vm._v(" "),
                _c("td", [_vm._v("お酒、プロレス、アニメ鑑賞")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("\n\t\t\t\t\t\tプロレス・・・ＦＲＥＥＤＯＭＳ、新日"),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t\tアニメ鑑賞・・・クソアニメ愛好家です！\n\t\t\t\t\t"
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "business_profile_wrap" }, [
          _c("p", [
            _vm._v("\n\t\t\t↓"),
            _c("br"),
            _vm._v("\n\t\t\t↓"),
            _c("br"),
            _vm._v("\n\t\t\t↓"),
            _c("br"),
            _vm._v("\n\t\t\t〜〜ここから転職向けプロフィール〜〜\n\t\t")
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("自己紹介")]),
          _vm._v(" "),
          _c("p", { staticClass: "profile_textarea" }, [
            _vm._v(
              "\n\t\t\tEC運営会社でフロントエンドエンジニアとして活動中の24歳。"
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\t「とりあえずやってみる」タイプで、綿密な準備をしてから目標を目指すより、トライアンドエラーで物事を進めていくのが得意。結果、業務上の評価でも「仕事は早いがケアレスミスが多い」となりがち。好きなエディタはSublimeText。\n\t\t"
            )
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("略歴")]),
          _vm._v(" "),
          _c("p", { staticClass: "profile_textarea" }, [
            _vm._v(
              "\n\t\t\t石川県で生まれ育つ。小学校低学年の頃初めてwindows98に触れ、以降ホームページビルダーで自分のホームページを作ったり、ハンゲームのアバターに小遣いをつぎ込む等、パソコンを中心とした生活を送り始める。"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n\t\t\t情報系の専門学校を卒業後上京し、従業員数100名ほどの受託開発会社にプログラマとして就職。入社から2年半の間に、官公庁案件を中心とする7件のwebサービス開発案件を経験する。サーバサイドのコーディング業務をメインとしつつ、モック作成やデザイン業務も担当した。"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n\t\t\tEC運営会社へ転職し、現在はサイトの要望改善、年数回行われる大型セールの対応、LP作成などの業務を担当。"
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n\t\t\tより詳細な職務内容、経歴等について興味を持たれた方はCONTACTよりお問い合わせください。\n\t\t"
            )
          ]),
          _vm._v(" "),
          _c("h2", [_vm._v("スキル")]),
          _vm._v(" "),
          _c("table", { staticClass: "profile_table" }, [
            _c("thead"),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("th", { attrs: { colspan: "2" } }, [_vm._v("種類")]),
                _vm._v(" "),
                _c("th", [_vm._v("経験年数")]),
                _vm._v(" "),
                _c("th", [_vm._v("レベル")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { attrs: { rowspan: "3" } }, [
                  _vm._v("言語（フロントエンド）")
                ]),
                _vm._v(" "),
                _c("td", [_vm._v("HTML5")]),
                _vm._v(" "),
                _c("td", [_vm._v("4年")]),
                _vm._v(" "),
                _c("td", [_vm._v("新規開発ができる")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("CSS3（SCSS）")]),
                _vm._v(" "),
                _c("td", [_vm._v("4年")]),
                _vm._v(" "),
                _c("td", [_vm._v("新規開発ができる")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("JavaScript")]),
                _vm._v(" "),
                _c("td", [_vm._v("4年")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("\n\t\t\t\t\t\tES6に準拠した改修業務ができる"),
                  _c("br"),
                  _vm._v(
                    "\n\t\t\t\t\t\tjQueryを使用した新規開発ができる\n\t\t\t\t\t"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { attrs: { rowspan: "3" } }, [
                  _vm._v("言語（バックエンド）")
                ]),
                _vm._v(" "),
                _c("td", [_vm._v("PHP")]),
                _vm._v(" "),
                _c("td", [_vm._v("2年")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v("CakePHP、Zend Frameworkを使用した新規開発ができる")
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("Java")]),
                _vm._v(" "),
                _c("td", [_vm._v("6ヶ月")]),
                _vm._v(" "),
                _c("td", [_vm._v("Springを使用した改修業務ができる")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("C#")]),
                _vm._v(" "),
                _c("td", [_vm._v("6ヶ月")]),
                _vm._v(" "),
                _c("td", [_vm._v("delphiからの移行作業ができる")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { attrs: { rowspan: "2" } }, [_vm._v("DB")]),
                _vm._v(" "),
                _c("td", [_vm._v("MySQL")]),
                _vm._v(" "),
                _c("td", [_vm._v("2年")]),
                _vm._v(" "),
                _c("td", [_vm._v("小規模なDB設計、基本操作ができる")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("Oracle")]),
                _vm._v(" "),
                _c("td", [_vm._v("6ヶ月")]),
                _vm._v(" "),
                _c("td", [_vm._v("小規模なDB設計、基本操作ができる")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("タスクランナー")]),
                _vm._v(" "),
                _c("td", [_vm._v("Gulp")]),
                _vm._v(" "),
                _c("td", [_vm._v("6ヶ月")]),
                _vm._v(" "),
                _c("td", [_vm._v("プラグインを導入して業務を最適化できる")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { attrs: { rowspan: "2" } }, [
                  _vm._v("バージョン管理ツール")
                ]),
                _vm._v(" "),
                _c("td", [_vm._v("Git")]),
                _vm._v(" "),
                _c("td", [_vm._v("2年")]),
                _vm._v(" "),
                _c("td", [_vm._v("CUIでの基本操作ができる")])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v("SVN")]),
                _vm._v(" "),
                _c("td", [_vm._v("2年")]),
                _vm._v(" "),
                _c("td", [_vm._v("基本操作ができる")])
              ])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }